import * as React from 'react'
import { LayoutApp } from 'components/shared/layouts/LayoutApp'
import { layoutService } from 'services/LayoutService'
import { simulationService } from 'services/SimulationService'
import { Meta } from 'components/shared/Meta'
import { Title } from '../shared/ui/Title'
import { PageFrame } from '../../base/components/ui/PageFrame'
import { ViewSimulationCharts } from './viewSimulation/Charts'
import { ViewSimulationControl } from './viewSimulation/Control'
import { useOnMount } from '../../base/hooks/useOnMount'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { ViewSimulationTour } from './viewSimulation/Tour'
import styles from './ViewSimulation.module.scss'

export const ViewSimulation = () => {
  const displayTour = !localStorage.getItem('ViewSimulationTour')
  const [tourState, setTourState] = React.useState(displayTour)

  useOnMount(() => {
    layoutService.setHeaderLarge(false)
    layoutService.setBreadcrumbs([{ label: 'Simulation' }])
    simulationService.initDefaultScenarios()
  })

  return (
    <LayoutApp>
      <Meta title="Simulation" />
      <div className={styles.root}>
        <div className={`${styles.content} tour-step-4`}>
          <PageFrame simple>
            <Title type={'h1'}>
              <span>Simulation</span>
              <span className={`${styles.tourFistStep} tour-step-1`}
                    onClick={() => setTourState(true)}
              >
                <HelpOutlineIcon />
              </span>
            </Title>
            <ViewSimulationCharts />
          </PageFrame>
        </div>
        <div className={styles.control}>
          <ViewSimulationControl />
        </div>
      </div>
      <ViewSimulationTour tourState={tourState} onTourStatechange={state => setTourState(state)} />
    </LayoutApp>
  )
}
